module.exports = __webpack_public_path__ + "static/media/collega.78c06bd5.svg";